// 企业年报

import React from 'react';
import Widget from '../../widget/Widget';
import WidgetAjax from '../../widget/WidgetAjax';
import WidgetInterfaceTable from '../../widget/WidgetInterfaceTable';
import Config from '../../config/Config';

class AnnualReports extends React.Component 
{
    constructor()
    {
        super();

        let url = Config.getHermesPanoramaURL();
        let UID = Config.getHermesPanoramaUID();

        let ENTNAME = Widget.getSessionStorage("entname");

        this.state = {
            url : url,
            params :{
                'user':UID,
                'ENTNAME' : ENTNAME,
            },
            ANCHEYEAR:"",
            reportList : [],
            baseInfo : {},
            column1 : [
                {name:"WEBTYPE", title:"网站网店类型", type:"string"},
                {name:"WEBSITNAME", title:"网站（网店）名称", type:"string"},
                {name:"WEBSITE", title:"网站（网店）网址", type:"string"}
            ],
            column2 : [
                {name:"INVNAME", title:"股东/发起人名称", type:"string"},
                {name:"LISUBCONAM", title:"累计认缴额", type:"string"},
                {name:"SUBCONFORM", title:"认缴出资方式", type:"string"},
                {name:"SUBCONDATE", title:"认缴出资日期", type:"string"},
                {name:"LIACCONAM", title:"累计实缴额", type:"string"},
                {name:"ACCONFORM", title:"实缴出资方式", type:"string"},
                {name:"ACCONDATE", title:"实缴出资日期", type:"string"}
            ],
            column3 : [
                {name:"ENTNAME", title:"被投企业名称", type:"string"},
                {name:"UNISCID", title:"被投企业统一社会信用代码", type:"string"}
            ],
            column4 : [
                {name:"ASSGRO",title:"资产总额", type:"string"},
                {name:"LIAGRO",title:"负债总额", type:"string"},
                {name:"VENDINC",title:"营业总收入", type:"string"},
                {name:"MAIBUSINC",title:"其中主营业务收入", type:"string"},
                {name:"PROGRO",title:"利润总额", type:"string"},
                {name:"NETINC",title:"净利润", type:"string"},
                {name:"RATGRO",title:"纳税总额", type:"string"},
                {name:"TOTEQU",title:"所有者权益合计", type:"string"}
            ],
            column5 : [
                {name:"MORE",title:"债权人", type:"string"},
                {name:"MORTGAGOR",title:"债务人", type:"string"},
                {name:"PRICLASECKIND",title:"主债权种类", type:"string"},
                {name:"PRICLASECAM",title:"主债权数额", type:"string"},
                {name:"PEFPERFORM",title:"履行债务的期限自", type:"string"},
                {name:"PEFPERTO",title:"履行债务的期限至", type:"string"},
                {name:"GUARANPERIOD",title:"保证的期间", type:"string"},
                {name:"GATYPE",title:"保证的方式", type:"string"}
            ],
            column6 : [
                {name:"INV", title:"股东名称", type:"string"},
                {name:"TRANSAMPR", title:"转让前股权比例", type:"string"},
                {name:"TRANSAMAFT", title:"转让后股权比例", type:"string"},
                {name:"ALTDATE", title:"股权变更日期", type:"string"}
            ],
            column7 : []
        }

        this.onLoadToken = this.onLoadToken.bind(this);

        
        Config.getHermesAccess( this.onLoadToken );

        this.annReportListCallback = this.annReportListCallback.bind(this);
        this.getAnnReportBaseInfo = this.getAnnReportBaseInfo.bind(this);
        this.onAnnReportBaseInfo = this.onAnnReportBaseInfo.bind(this);
    };

    annReportListCallback(result, params)
    {
        if( result.status===0 )
        {
            for (let i = 0; i < result.results.length; i++) 
            {
                for (let y = i; y > 0; y--) 
                {
                    if (result.results[y].ANCHEYEAR > result.results[y - 1].ANCHEYEAR) 
                    {
                        [result.results[y - 1], result.results[y]] = [result.results[y], result.results[y - 1]];
                    }
                }
            }

						if( result.results.length>0 )
						{
                this.setState({reportList:result.results});
                this.getAnnReportBaseInfo(result.results[0].ANCHEYEAR);
                this.setState({ANCHEYEAR:result.results[0].ANCHEYEAR});
            }
        }
    }

    /**
     * 获取 token 回调函数
     * @param {*} result 
     * @returns 
     */
    onLoadToken( result )
    {
        const {url } = this.state;
        
        let { params} = this.state;
        
        if( result.status===0 )
        {
            params["access"] =  result.result.token;

            this.setState({params:params}); 

            WidgetAjax.ajax({url : url, params : {...params, ...{"service":"getAnnReportList"}}, callback : this.annReportListCallback, backParam:{params:{}} });
        }
        else
        {
            return ;
        }  
    }

    /**
     * 
     * @returns 年报基本信息
     */
    getAnnReportBaseInfo( ANCHEYEAR )
    {
        const {url } = this.state;
        
        let { params } = this.state;

        if( ANCHEYEAR==="" )
        {
            return;
        }

        WidgetAjax.ajax({url : url, params : {...params, ...{"service":"getAnnReportBaseInfo", "ANCHEYEAR":ANCHEYEAR}}, callback : this.onAnnReportBaseInfo, backParam:{params:{...params, ...{"service":"getAnnReportBaseInfo", "ANCHEYEAR":ANCHEYEAR}}} });
    }

    onAnnReportBaseInfo(result, params)
    {
        if( result.status===0 )
        {
            this.setState({baseInfo:result.result, "ANCHEYEAR":params.ANCHEYEAR});

        }
    }

    change( item )
    {
        for( let i=0; i<item.target.parentNode.childNodes.length; i++ )
        {
            item.target.parentNode.childNodes[i].className = "title-label";
        }

        item.target.className = 'title-label title-label-active';

        this.getAnnReportBaseInfo(item.target.textContent);
    };

    componentDidUpdate( )
    {
        let entname = Widget.getSessionStorage("entname");

        let { params } = this.state;

        if( params.ENTNAME!==entname )
        {
            this.state["params"]["ENTNAME"] = entname;
            Config.getHermesAccess( this.onLoadToken );
        }  
    }

    render()
    {
        const {url, params, reportList, baseInfo, ANCHEYEAR, column1, column2, column3, column4, column5, column6} = this.state;

        return(
            <div className="page">
                <div className="page-weidu entity-title">
                {
                    reportList.map((item, index) => {
                        if( index===0 )
                        {
                            return<div className="title-label title-label-active" onClick={this.change.bind(this)}>{item.ANCHEYEAR}</div>
                        }
                        else
                        {
                            return<div className="title-label " onClick={this.change.bind(this)}>{item.ANCHEYEAR}</div>
                        }
                    })
                }   
                </div>

                <div className="page-content page-overflow entity-content white">
                    <div className="content-bottom">
                        <div className="content-canvas content-report">
                            <div className="content-title">
                                
                                <div className="font" style={{padding:"0 20px",margin:"0"}}>
                                    <span>{ANCHEYEAR} 年报</span>
                                </div>
                            </div>
                            <div className="content-detail" style={{padding:"0 20px"}}>
                                <div className="content-title">
                                    <div className="img">
                                        <img src={require("../../img/riskCompass/bt_left.svg")} alt="es-lint want to get"></img>
                                    </div>
                                    <div className="font">
                                        <span>企业基本信息</span>
                                    </div>
                                </div>
                                <div className="baseInfo report-baseInfo">
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td >企业名称</td>
                                                <td>{baseInfo.ENTNAME}</td>
                                                <td >统一社会信用代码</td>
                                                <td>{baseInfo.UNISCID}</td>
                                            </tr>
                                            <tr>
                                                <td >经营状态</td>
                                                <td>{baseInfo.REGSTATE}</td>
                                                <td >联系电话</td>
                                                <td>{baseInfo.TEL}</td>
                                            </tr>
                                            <tr>
                                                <td >电子邮箱</td>
                                                <td>{baseInfo.EMAIL}</td>
                                                <td >归属省份</td>
                                                <td>{baseInfo.DISTRICT}</td>
                                            </tr>
                                            <tr>
                                                <td >邮政编码</td>
                                                <td>{baseInfo.POSTALCODE}</td>
                                                <td >从业人数</td>
                                                <td>{baseInfo.EMPNUM}</td>
                                            </tr>
                                            <tr>
                                                <td >企业通信地址</td><td colSpan="3" >{baseInfo.ADDR}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="content-detail no-dotted">
                                <WidgetInterfaceTable options={{
                                    'url':url,
                                    'records':5,
                                    'title':'网店或网站信息'
                                }} columns={column1} params={{...params, ...{"service":"getAnnReportWebsiteInfo", "ANCHEYEAR":ANCHEYEAR}}}></WidgetInterfaceTable>
                                
                            </div>

                            <div className="content-detail no-dotted ">
                                <WidgetInterfaceTable options={{
                                    'url':url,
                                    'records':5,
                                    'title':'股东及出资信息'
                                }} columns={column2} params={{...params, ...{"service":"getAnnReportSubCapitalInfo", "ANCHEYEAR":ANCHEYEAR}}}></WidgetInterfaceTable>
                                
                            </div>

                            <div className="content-detail no-dotted" >
                                <WidgetInterfaceTable options={{
                                    'url':url,
                                    'records':5,
                                    'title':'对外投资信息'
                                }} columns={column3} params={{...params, ...{"service":"getAnnReportForinvestmentInfo", "ANCHEYEAR":ANCHEYEAR}}}></WidgetInterfaceTable>
                            </div>

                            <div className="content-detail no-dotted" >
                                <WidgetInterfaceTable options={{
                                    'url':url,
                                    'records':5,
                                    'title':'企业财务状况'
                                }} columns={column4} params={{...params, ...{"service":"getAnnReportAssetInfo", "ANCHEYEAR":ANCHEYEAR}}}></WidgetInterfaceTable>
                            </div>

                            <div className="content-detail no-dotted">
                                <WidgetInterfaceTable options={{
                                    'url':url,
                                    'records':5,
                                    'title':'对外担保信息'
                                }} columns={column5} params={{...params, ...{"service":"getAnnReportForguaranteeInfo", "ANCHEYEAR":ANCHEYEAR}}}></WidgetInterfaceTable>
                            </div>

                            <div className="content-detail no-dotted">
                                <WidgetInterfaceTable options={{
                                    'url':url,
                                    'records':5,
                                    'title':'股权变更信息'
                                }} columns={column6} params={{...params, ...{"service":"getAnnReportAlterStockInfo", "ANCHEYEAR":ANCHEYEAR}}}></WidgetInterfaceTable>
                            </div>
                                
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default AnnualReports;